var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "password-input-wrapper" }, [
    _c(
      "input",
      _vm._b(
        {
          class: ["form-control", _vm.inputClass],
          attrs: {
            type: _vm.showPassword ? "text" : "password",
            name: _vm.name,
            tabindex: _vm.tabindex,
            autocomplete: _vm.autocomplete,
            size: _vm.size,
            required: _vm.required,
          },
          domProps: { value: _vm.value },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event.target.value)
            },
          },
        },
        "input",
        _vm.$attrs,
        false
      )
    ),
    _c(
      "button",
      {
        staticClass: "password-toggle-btn",
        attrs: {
          type: "button",
          "aria-label": _vm.showPassword
            ? _vm.T.passwordHidePassword
            : _vm.T.passwordShowPassword,
          title: _vm.showPassword
            ? _vm.T.passwordHidePassword
            : _vm.T.passwordShowPassword,
        },
        on: { click: _vm.togglePasswordVisibility },
      },
      [
        _c("font-awesome-icon", {
          attrs: { icon: ["fas", _vm.showPassword ? "eye-slash" : "eye"] },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }